import type { IUiLabelsResponse } from "@/model/ui-labels";

export const DEFAULT_NETWORK_VALUES = {
  IN: "In Network",
  OUT: "Out of Network",
} as const;

export const DEFAULT_PAPERLESS_EOB_VALUES = {
  CONFIRM_BTN: "Go Paperless",
  DISMISS_BTN: "Remind Me Later",
  DONOT_AST_AGAIN_BTN: "Don't Ask Again",
  BODY: "Help us go green and make things easier for you. View your EOBs online instantly—secure, fast, and convenient.",
  TITLE: "Switch to Paperless EOBs!",
} as const;

export const FALLBACK_UI_LABELS_VALUES: IUiLabelsResponse = {
  summary: {
    status_message: "",
    member_id: "",
    status_code: "",
    query_id: "",
    group_id: "",
    query: "",
    query_time: 0,
  },
  data: {
    coverageTiers: {
      tier1: {
        label: "Tier 1",
        description: "",
      },
    },
    network: {
      in: DEFAULT_NETWORK_VALUES.IN,
      out: DEFAULT_NETWORK_VALUES.OUT,
    },
    paperlessEOB: {
      action_button: {
        confirm: DEFAULT_PAPERLESS_EOB_VALUES.CONFIRM_BTN,
        cancel: DEFAULT_PAPERLESS_EOB_VALUES.DISMISS_BTN,
        do_not_ask_again: DEFAULT_PAPERLESS_EOB_VALUES.DONOT_AST_AGAIN_BTN,
      },
      body: DEFAULT_PAPERLESS_EOB_VALUES.BODY,
      title: DEFAULT_PAPERLESS_EOB_VALUES.TITLE,
    },
  },
};
